export const default_article = {
  title: "",
  topic: "",
  leadMedia: "",
  leadParagraph: "",
  layers: [{ type: "", data: "" }],
};
export const default_tags = {
  event: "",
  product: "",
};



// WEBPACK FOOTER //
// ./src/screens/SuperArticles/constants/default.js